export default {
  title: 'Acordo',
  description: 'Será cobrado um valor de {{amount}} por mês se não cancelar o período de teste.',
  bill_at_launch_date: 'Primeira cobrança na data de lançamento',
  bill_date: 'Data de cobrança: {{date}}',
  bill_date_after_launch: 'Primeira data de cobrança: {{days}} dias após o lançamento',
  sign_agreement: 'Por favor, assine o acordo de subscrição e participação do restaurante',
  restaurant: 'Restaurante',
  agreement:
    'Aceito os <a href="{{terms_url}}" target="_blank" rel="noreferrer noopener">termos da plataforma</a>. Posso cancelar a subscrição a qualquer momento notificando {{provider}} do cancelamento. A subscrição será cancelada e o acordo de pagamento revogado assim que o Restaurante contactar {{provider}} relativamente ao cancelamento por email ou WhatsApp. Não serão feitas mais cobranças ao restaurante após esse momento. Concordo que o meu consentimento eletrónico equivale à assinatura deste documento e compreendo que a minha assinatura eletrónica é vinculativa.',
};
